require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _StyledText = _interopRequireDefault(require("./StyledText"));

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/Typography/Title.tsx";

var Title = function Title(props) {
  return React.createElement(_StyledText["default"], (0, _extends2["default"])({}, props, {
    alpha: 0.87,
    family: "medium",
    style: [styles.text, props.style],
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31
    }
  }));
};

var _default = Title;
exports["default"] = _default;

var styles = _reactNative.StyleSheet.create({
  text: {
    fontSize: 20,
    lineHeight: 30,
    marginVertical: 2,
    letterSpacing: 0.15
  }
});